import { ParticipantContext } from "providers/ParticipantProvider";
import { useContext } from "react";

export default function useParticipantContext() {
  const context = useContext(ParticipantContext);
  if (!context) {
    throw new Error(
      "useParticipantContext must be used within a ParticipantProvider"
    );
  }
  return context;
}
